"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

require("./Paragraph.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @visibleName Paragraphs
 */
function Paragraph(_ref) {
  var fontSize = _ref.fontSize,
      children = _ref.children,
      color = _ref.color,
      margin = _ref.margin,
      textAlign = _ref.textAlign,
      className = _ref.className;
  var classes = ['paragraph', className];
  var styles = {
    color: color,
    margin: margin,
    textAlign: textAlign
  };
  classes.push(Paragraph.fontSizes[fontSize]);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: classes.join(' '),
    style: styles
  }, children);
}

Paragraph.propTypes = {
  /** Elements to be rendered as children of this component */
  children: _propTypes.default.node,

  /** The paragraph font size */
  fontSize: _propTypes.default.oneOf(['16', '16B', '14', '14B', '12', '12B']),

  /** Color of text */
  color: _propTypes.default.string,

  /** Margins */
  margin: _propTypes.default.string,

  /** Text align in paragraph */
  textAlign: _propTypes.default.string
};
Paragraph.defaultProps = {
  fontSize: '16',
  color: _Colors.default.vagaVesi,
  margin: '0'
};
Paragraph.fontSizes = {
  16: 'css-16',
  '16B': 'css-16B',
  14: 'css-14',
  '14B': 'css-14B',
  12: 'css-12',
  '12B': 'css-12B'
};
var _default = Paragraph;
exports.default = _default;